import Section from '../presale/section';
import React from "react";

export default function Landing() {
    return (
        <div className="min-h-screen landing">
            <Section />
        </div>
    );
}